import './kardex.css';
import HorasRegaloSesion from '../../../components/HorasRegaloSesion';
// SesionKardexClientesPage.tsx - Versión Completa Actualizada
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { fetchSesionesByCita, Sesion } from '../../../services/sesionesService';
import { fetchCitaById, Cita } from '../../../services/citasService';
import {
    Clock,
    Calendar,
    ArrowLeft,
    Info,
    Loader,
    Gift,
    CreditCard,
    Banknote,
    DollarSign,
    CheckCircle,
    AlertCircle,
    MoreVertical,
    ClipboardCheck
} from 'lucide-react';
import AsistenciaSesionModal from '../../shared/AsistenciaSesionModal';
import PagoSesionModal from '../pagos/PagoSesionModal';
import HistorialPagosModal from '../pagos/HistorialPagosSesionesModal';
import AdminGiftStart from '../../../components/horasRegalo/AdminGiftStart';
import {
    fetchUsoHorasRegaloPorSesion,
    fetchUsoHorasRegaloPorCliente,
    UsoHorasRegalo
} from '../../../services/usarHorasDeRegaloService';

// Definir la paleta de colores de Co Marca Cowork Group
const COLORS = {
    primaryAction: '#c1348b',
    corporate: '#8f1f64',
    highlightText: '#ea8406',
    highlightBg: '#ffd97c',
    blue: '#61257b',
    teal: '#8b3fa8'
};

const SesionKardexClientesPage: React.FC = () => {
    const { citaId } = useParams<{ citaId: string }>();
    const location = useLocation();
    const navigate = useNavigate();
    const [sesiones, setSesiones] = useState<Sesion[]>([]);
    const [cita, setCita] = useState<Cita | null>(null);
    const [loading, setLoading] = useState(true);

    const [modalPagoAbierto, setModalPagoAbierto] = useState(false);
    const [sesionSeleccionada, setSesionSeleccionada] = useState<Sesion | null>(null);
    const [modalHorasRegaloAbierto, setModalHorasRegaloAbierto] = useState(false);
    const [horasRegaloSesion, setHorasRegaloSesion] = useState<UsoHorasRegalo | null>(null);
    const [horasRegaloCliente, setHorasRegaloCliente] = useState<UsoHorasRegalo[]>([]);
    const [cargandoHorasRegalo, setCargandoHorasRegalo] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const usuarioId = searchParams.get('usuarioId') || searchParams.get('clienteId');
    const [modalHistorialAbierto, setModalHistorialAbierto] = useState(false);
    const [modalUsarHorasAbierto, setModalUsarHorasAbierto] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState<number | null>(null);
    const [modalAsistenciaAbierto, setModalAsistenciaAbierto] = useState(false);

    const toggleDropdown = (sesionId: number) => {
        setOpenDropdownId(openDropdownId === sesionId ? null : sesionId);
    };

    const abrirModalUsarHoras = async (sesion: Sesion) => {
        setSesionSeleccionada(sesion);
        setCargandoHorasRegalo(true);

        try {
            let horasRegalo = await fetchUsoHorasRegaloPorSesion(sesion.id);

            if (horasRegalo) {
                const horasDisponibles = (horasRegalo.minutos_disponibles ?? 0) / 60;

                if (horasDisponibles <= 0 && usuarioId) {
                    const todasHorasRegalo = await fetchUsoHorasRegaloPorCliente(Number(usuarioId));
                    const horasClienteDisponibles = todasHorasRegalo.reduce((total, uso) =>
                        total + (uso.minutos_disponibles ?? 0) / 60, 0);

                    if (horasClienteDisponibles <= 0) {
                        alert('No hay horas regalo disponibles para usar');
                        return;
                    }

                    setHorasRegaloCliente(todasHorasRegalo.filter(uso => (uso.minutos_disponibles ?? 0) > 0));
                    setHorasRegaloSesion(null);
                } else if (horasDisponibles <= 0) {
                    alert('No hay horas regalo disponibles en esta sesión');
                    return;
                } else {
                    setHorasRegaloSesion(horasRegalo);
                    setHorasRegaloCliente([]);
                }
            } else if (usuarioId) {
                const todasHorasRegalo = await fetchUsoHorasRegaloPorCliente(Number(usuarioId));
                const horasDisponibles = todasHorasRegalo.reduce((total, uso) =>
                    total + (uso.minutos_disponibles ?? 0) / 60, 0);

                if (horasDisponibles <= 0) {
                    alert('No hay horas regalo disponibles para usar');
                    return;
                }

                setHorasRegaloCliente(todasHorasRegalo.filter(uso => (uso.minutos_disponibles ?? 0) > 0));
                setHorasRegaloSesion(null);
            } else {
                alert('No se encontraron horas regalo disponibles');
                return;
            }

            setModalUsarHorasAbierto(true);
        } catch (error) {
            console.error('Error cargando horas regalo:', error);
            alert('Error al cargar las horas regalo');
        } finally {
            setCargandoHorasRegalo(false);
        }
    };

    const abrirModalHorasRegalo = async (sesion: Sesion) => {
        setSesionSeleccionada(sesion);
        setCargandoHorasRegalo(true);

        try {
            if (!sesion.tiene_horas_regalo) {
                setHorasRegaloSesion(null);
                setHorasRegaloCliente([]);
                setModalHorasRegaloAbierto(true);
                return;
            }

            const horasRegalo = await fetchUsoHorasRegaloPorSesion(sesion.id);

            if (horasRegalo) {
                setHorasRegaloSesion(horasRegalo);
                setHorasRegaloCliente([]);
            } else {
                setHorasRegaloSesion(null);
                setHorasRegaloCliente([]);
            }
        } catch (error) {
            console.error('Error cargando horas regalo:', error);
            setHorasRegaloSesion(null);
            setHorasRegaloCliente([]);
        } finally {
            setCargandoHorasRegalo(false);
            setModalHorasRegaloAbierto(true);
        }
    };

    const abrirModalHistorial = (sesion: Sesion) => {
        setSesionSeleccionada(sesion);
        setModalHistorialAbierto(true);
    };

    const abrirModalPago = (sesion: Sesion) => {
        setSesionSeleccionada(sesion);
        setModalPagoAbierto(true);
    };

    const getEstadoColor = (estado: string) => {
        switch (estado) {
            case 'completo': return {
                bg: `bg-[${COLORS.teal}]/10`,
                text: `text-[${COLORS.teal}]`,
                border: `border-[${COLORS.teal}]/20`,
                icon: <CheckCircle className="w-3 h-3 mr-1.5" />
            };
            case 'parcial': return {
                bg: `bg-[${COLORS.highlightBg}]/20`,
                text: `text-[${COLORS.highlightText}]`,
                border: `border-[${COLORS.highlightBg}]/30`,
                icon: <AlertCircle className="w-3 h-3 mr-1.5" />
            };
            case 'pendiente': return {
                bg: `bg-[${COLORS.primaryAction}]/10`,
                text: `text-[${COLORS.primaryAction}]`,
                border: `border-[${COLORS.primaryAction}]/20`,
                icon: <AlertCircle className="w-3 h-3 mr-1.5" />
            };
            default: return {
                bg: 'bg-gray-100',
                text: 'text-gray-800',
                border: 'border-gray-200',
                icon: <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mr-1.5"></div>
            };
        }
    };

    const getEstadoLabel = (estado: string) => {
        switch (estado) {
            case 'pendiente': return 'PENDIENTE';
            case 'parcial': return 'PAGADO PARCIAL';
            case 'completo': return 'PAGADO COMPLETO';
            default: return estado.toUpperCase();
        }
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                const [citaData, sesionesData] = await Promise.all([
                    fetchCitaById(Number(citaId)),
                    fetchSesionesByCita(Number(citaId))
                ]);
                setCita(citaData);
                setSesiones(sesionesData);
            } catch (err) {
                console.error('Error fetching data:', err);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, [citaId]);

    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('es-BO', {
            style: 'currency',
            currency: 'BOB'
        }).format(amount);
    };

    const recargarSesiones = async () => {
        try {
            const sesionesData = await fetchSesionesByCita(Number(citaId));
            setSesiones(sesionesData);
            // Si el modal de horas regalo estaba abierto, también refrescar esos datos
            if (modalHorasRegaloAbierto && sesionSeleccionada) {
                const horasRegalo = await fetchUsoHorasRegaloPorSesion(sesionSeleccionada.id);
                setHorasRegaloSesion(horasRegalo);
            }
        } catch (err) {
            console.error('Error recargando sesiones:', err);
        }
    };

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(year, month - 1, day);

        return date.toLocaleDateString('es-ES', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const formatHours = (hours: number) => {
        return `${hours} ${hours === 1 ? 'hora' : 'horas'}`;
    };

    const renderDropdownButton = (sesion: Sesion) => {
        return (
            <div className="relative">
                <button
                    onClick={() => toggleDropdown(sesion.id)}
                    className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600"
                >
                    <MoreVertical className="w-5 h-5" />
                </button>

                {openDropdownId === sesion.id && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-10 border border-gray-200 py-1">
                        <div className="px-3 py-2 text-xs text-gray-500 font-medium border-b border-gray-100 mb-1">
                            Acciones
                        </div>
                        <div>
                            {cita?.espacio_servicio && (
                            <button
                                onClick={() => {
                                    setSesionSeleccionada(sesion);
                                    setModalAsistenciaAbierto(true);
                                    setOpenDropdownId(null);
                                }}
                                className="flex items-center w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                            >
                                <ClipboardCheck className="w-4 h-4 mr-3 text-gray-400" />
                                <span>Control de asistencia</span>
                            </button>
                            )}

                            <button
                                onClick={() => {
                                    abrirModalHistorial(sesion);
                                    setOpenDropdownId(null);
                                }}
                                className="flex items-center w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                            >
                                <Clock className="w-4 h-4 mr-3 text-gray-400" />
                                <span>Ver Historial</span>
                            </button>

                            <button
                                onClick={() => {
                                    abrirModalHorasRegalo(sesion);
                                    setOpenDropdownId(null);
                                }}
                                className="flex items-center w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                            >
                                <Gift className="w-4 h-4 mr-3 text-gray-400" />
                                <span>Horas Regalo</span>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="kardex-page">
            <style>
                {`
                .scrollbar-estilizado {
                    scrollbar-width: thin;
                    scrollbar-color: rgba(156, 163, 175, 0.5) transparent;
                }
                .scrollbar-estilizado::-webkit-scrollbar {
                    width: 6px;
                }
                .scrollbar-estilizado::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 3px;
                }
                .scrollbar-estilizado::-webkit-scrollbar-thumb {
                    background-color: rgba(156, 163, 175, 0.5);
                    border-radius: 3px;
                    transition: background-color 0.2s ease;
                }
                .scrollbar-estilizado::-webkit-scrollbar-thumb:hover {
                    background-color: rgba(156, 163, 175, 0.7);
                }
                `}
            </style>

            {/* MODALES */}
            <PagoSesionModal
                abierto={modalPagoAbierto}
                onCerrar={() => setModalPagoAbierto(false)}
                sesion={sesionSeleccionada}
                clienteId={usuarioId}
                onPagoExitoso={recargarSesiones}
            />
            <HistorialPagosModal
                abierto={modalHistorialAbierto}
                onCerrar={() => setModalHistorialAbierto(false)}
                sesionId={sesionSeleccionada?.id || 0}
            />
            <AdminGiftStart
                open={modalUsarHorasAbierto}
                onClose={() => setModalUsarHorasAbierto(false)}
                benefitId={horasRegaloSesion?.id}
                clientId={usuarioId ? Number(usuarioId) : undefined}
                onStarted={recargarSesiones}
            />
            {modalAsistenciaAbierto && sesionSeleccionada && (
                <AsistenciaSesionModal
                    sesionId={sesionSeleccionada.id}
                    modoPersonal
                    onClose={() => setModalAsistenciaAbierto(false)}
                />
            )}

            {/* MODAL HORAS REGALO */}
            {modalHorasRegaloAbierto && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
                    <div className="bg-white rounded-xl w-full max-w-4xl mx-4 shadow-2xl relative">
                        <div className="bg-gradient-to-r from-[#8f1f64] to-[#c1348b] p-6 text-white">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center gap-3">
                                    <Gift size={24} />
                                    <div>
                                        <h2 className="text-xl font-bold">
                                            {horasRegaloSesion ? 'Horas Regalo de la Sesión' : 'Horas Regalo'}
                                        </h2>
                                        <p className="text-white/80 text-sm">
                                            Sesión #{sesionSeleccionada?.id}
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setModalHorasRegaloAbierto(false)}
                                    className="text-white hover:text-white/80 transition-colors p-1 rounded-full hover:bg-white/10"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className="p-6 max-h-[60vh] overflow-y-auto">
                            {cargandoHorasRegalo ? (
                                <div className="flex flex-col items-center justify-center py-8">
                                    <Loader className="animate-spin text-[#61257b] mb-4" size={32} />
                                    <p className="text-gray-600">Cargando horas regalo...</p>
                                </div>
                            ) : horasRegaloSesion ? (
                                <div className="space-y-6">
                                    <div className="bg-[#8b3fa8]/10 border border-[#8b3fa8]/20 rounded-lg p-4">
                                        <h4 className="font-semibold text-[#8b3fa8] mb-2">Información de la Sesión</h4>
                                        <div className="space-y-2 text-sm">
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Fecha:</span>
                                                <span className="font-medium">
                                                    {formatDate(sesionSeleccionada?.fecha_inicio || '')}
                                                </span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Horario:</span>
                                                <span className="font-medium">
                                                    {sesionSeleccionada?.hora_inicio} - {sesionSeleccionada?.hora_fin || 'En curso'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex justify-between items-center p-4 bg-green-50 border border-green-200 rounded-lg">
                                            <div>
                                                <h4 className="font-semibold text-green-800">Horas Regalo Aplicadas</h4>
                                                <p className="text-sm text-green-600">Total asignado a esta sesión</p>
                                            </div>
                                            <div className="text-right">
                                                <span className="text-2xl font-bold text-green-800">
                                                    {horasRegaloSesion.horas_regalo_aplicadas}
                                                </span>
                                                <span className="text-green-600 ml-1">horas</span>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-3 gap-4 text-sm">
                                            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                                <span className="text-gray-500 block mb-1">Asignadas</span>
                                                <span className="font-medium text-lg">
                                                    {horasRegaloSesion.horas_regalo_aplicadas} horas
                                                </span>
                                            </div>
                                            <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                                                <span className="text-red-500 block mb-1">Usadas</span>
                                                <span className="font-medium text-lg text-red-700">
                                                    {horasRegaloSesion.horas_usadas || 0} horas
                                                </span>
                                            </div>
                                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                                <span className="text-blue-500 block mb-1">Disponibles</span>
                                                <span className="font-medium text-lg text-blue-700">
                                                    {(horasRegaloSesion.minutos_disponibles ?? 0) / 60} horas
                                                </span>
                                            </div>
                                        </div>

                                        {horasRegaloSesion.excedente_cobrado !== "0.00" && (
                                            <div className="bg-[#ffd97c]/30 border border-[#ffd97c] rounded-lg p-4">
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <h4 className="font-semibold text-[#ea8406]">Excedente Cobrado</h4>
                                                        <p className="text-sm text-[#ea8406]">Por horas adicionales</p>
                                                    </div>
                                                    <span className="font-bold text-[#ea8406]">
                                                        {formatCurrency(parseFloat(horasRegaloSesion.excedente_cobrado))}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        <div className="border-t pt-4">
                                            <h4 className="font-semibold text-gray-900 mb-2">Configuración Asociada</h4>
                                            <p className="text-sm text-gray-600">
                                                {horasRegaloSesion.config_horas_regalo_display}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center py-8">
                                    <Gift className="mx-auto text-gray-400 mb-4" size={48} />
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                                        {sesionSeleccionada?.tiene_horas_regalo
                                            ? 'Horas regalo no encontradas'
                                            : 'Esta sesión no tiene horas regalo'
                                        }
                                    </h3>
                                </div>
                            )}
                        </div>

                        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 rounded-b-xl">
                            <div className="flex justify-end">
                                <button
                                    onClick={() => setModalHorasRegaloAbierto(false)}
                                    className="px-6 py-2.5 bg-[#61257b] text-white rounded-lg hover:bg-[#8b3fa8] transition-colors font-medium"
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="kardex-content space-y-6">
                <header className="kd-panel">
                    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
                        <div>
                            <span className="kd-eyebrow">Kardex · Reserva {cita?.codigo || citaId}</span>
                            <h1 className="kd-heading">Sesiones de la reserva</h1>
                            <p className="kd-subtitle">Consulta períodos, pagos y horas de regalo de cada sesión.</p>
                        </div>
                        <button onClick={() => navigate(`/kardex-citas/detalle/${usuarioId}`)} className="kd-button">
                            <ArrowLeft size={18} /> Volver al kardex
                        </button>
                    </div>
                </header>
                <div className="kd-metrics" aria-label="Resumen de sesiones" aria-busy={loading}>
                    {[
                        { label: 'Sesiones registradas', value: sesiones.length.toString() },
                        { label: 'Valor de las sesiones', value: formatCurrency(sesiones.reduce((total, item) => total + Number(item.precio_con_descuento || 0), 0)) },
                        { label: 'Total pagado', value: formatCurrency(sesiones.reduce((total, item) => total + Number(item.monto_pagado || 0), 0)) },
                        { label: 'Saldo pendiente', value: formatCurrency(sesiones.reduce((total, item) => total + Number(item.saldo_pendiente || 0), 0)) },
                    ].map(metric => (
                        <div className="kd-metric" key={metric.label}>
                            <p className="kd-metric-label">{metric.label}</p>
                            <p className="kd-metric-value">{loading ? '—' : metric.value}</p>
                        </div>
                    ))}
                </div>

                {/* CONTENEDOR PRINCIPAL */}
                <div className="kd-panel">
                    <div className="pb-5 border-b border-gray-100">
                        <div className="flex items-center justify-between">
                            <div>
                                <h2 className="font-semibold text-gray-900">Detalle de las sesiones</h2>
                                <p className="text-sm text-gray-500 mt-1">
                                    Fechas, importes y acciones disponibles por período
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="pt-6">
                        {loading ? (
                            <div className="flex flex-col items-center justify-center py-12">
                                <Loader className="animate-spin text-[#61257b] mb-4" size={40} />
                                <p className="text-gray-600 text-lg">Cargando sesiones...</p>
                            </div>
                        ) : sesiones.length === 0 ? (
                            <div className="bg-[#ffd97c]/30 border-l-4 border-[#ea8406] p-5 rounded-lg">
                                <div className="flex items-start">
                                    <Info className="text-[#ea8406] mt-0.5 mr-3 flex-shrink-0" />
                                    <div>
                                        <h3 className="text-lg font-medium text-[#ea8406] mb-1">No hay sesiones registradas</h3>
                                        <p className="text-gray-700">
                                            Esta cita aún no tiene sesiones asociadas.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
                                {sesiones.map((sesion) => {
                                    const estadoColors = getEstadoColor(sesion.estado_pago);
                                    return (
                                        <div
                                            key={sesion.id}
                                            className="kd-session-card transition-colors"
                                        >
                                            {/* HEADER DE LA TARJETA */}
                                            <div className="p-5 border-b border-gray-100">
                                                <div className="flex justify-between items-start mb-3">
                                                    <div>
                                                        <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${estadoColors.bg} ${estadoColors.text} ${estadoColors.border} mb-3`}>
                                                            {estadoColors.icon}
                                                            {getEstadoLabel(sesion.estado_pago)}
                                                        </div>
                                                        <h3 className="font-semibold text-gray-900 text-lg">Sesión #{sesion.id}</h3>
                                                    </div>
                                                    {renderDropdownButton(sesion)}
                                                </div>

                                                <div className="flex items-center gap-2">
                                                    <div className={`px-2 py-0.5 rounded-full text-xs font-medium ${sesion.fin_semana === 'Sí'
                                                        ? 'bg-green-100 text-green-800'
                                                        : 'bg-gray-100 text-gray-800'
                                                        }`}>
                                                        {sesion.fin_semana === 'Sí' ? 'Tiene fin de semana' : 'Solo días hábiles'}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* CONTENIDO DE LA TARJETA */}
                                            <div className="p-5">
                                                <div className="space-y-4">
                                                    <HorasRegaloSesion sesion={sesion} />
                                                    {/* FECHA */}
                                                    <div className="flex items-center text-sm text-gray-600">
                                                        <Calendar className="w-4 h-4 mr-2 text-gray-400" />
                                                        <span>
                                                            {formatDate(sesion.fecha_inicio)} - {formatDate(sesion.fecha_fin)}
                                                        </span>
                                                    </div>

                                                    {/* HORARIO */}
                                                    <div className="flex items-center text-sm text-gray-600">
                                                        <Clock className="w-4 h-4 mr-2 text-gray-400" />
                                                        <span>
                                                            {sesion.hora_inicio} – {sesion.hora_fin || 'En curso'}
                                                            <span className="ml-2">({formatHours(sesion.horas)})</span>
                                                        </span>
                                                    </div>

                                                    {/* ✅ PRECIO CON SOPORTE A TEMPORIZADOR */}
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center">
                                                            <div className="w-9 h-9 rounded-lg bg-[#8b3fa8]/10 flex items-center justify-center mr-3">
                                                                <DollarSign className="w-5 h-5 text-[#8b3fa8]" />
                                                            </div>
                                                            <div>
                                                                <div className="text-xs text-gray-500">Precio Cobrado</div>

                                                                {/* Mostrar el precio con descuento (ya calcula precio_activo en el backend) */}
                                                                <div className="font-semibold text-gray-900">
                                                                    {formatCurrency(sesion.precio_con_descuento)}
                                                                </div>

                                                                {/* Mostrar leyenda si es temporizador */}
                                                                {typeof sesion.precio_temporizador === "number" && sesion.precio_temporizador !== null && (
                                                                    <div className="text-[11px] text-[#c1348b] font-medium mt-0.5">
                                                                        ⏱️ Calculado por temporizador
                                                                    </div>
                                                                )}

                                                                {/* Mostrar detalles de precios si hay temporizador o descuento */}
                                                                {typeof sesion.precio_temporizador === "number" && sesion.precio_temporizador !== null && (
                                                                    <div className="text-xs text-gray-500 line-through mt-1">
                                                                        Base: {formatCurrency(sesion.precio)}
                                                                    </div>
                                                                )}

                                                                {(typeof sesion.precio_temporizador !== "number" || sesion.precio_temporizador === null) &&
                                                                    sesion.precio_con_descuento !== sesion.precio && (
                                                                        <div className="text-xs text-gray-500 line-through">
                                                                            {formatCurrency(sesion.precio)}
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ESTADO DE PAGO */}
                                                    <div className="pt-4 border-t border-gray-100">
                                                        <div className="flex items-center justify-between text-sm">
                                                            <div className="flex items-center">
                                                                <CreditCard className="w-4 h-4 mr-2 text-gray-400" />
                                                                <span className="text-gray-600">Estado de pago</span>
                                                            </div>
                                                            <div className="text-right">
                                                                <div className="font-medium text-gray-900">
                                                                    Pagado: {formatCurrency(sesion.monto_pagado)}
                                                                </div>
                                                                <div className="text-gray-600">
                                                                    Saldo: {formatCurrency(sesion.saldo_pendiente)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ACCIONES */}
                                                <div className="kd-session-actions mt-6 border-t border-gray-100">
                                                    <div className="grid grid-cols-2 gap-2">
                                                        <button
                                                            onClick={() => abrirModalUsarHoras(sesion)}
                                                            disabled={!sesion.tiene_horas_regalo || (sesion.horas_regalo_disponibles ?? 0) <= 0}
                                                            className={`col-span-2 flex items-center justify-center px-3 py-2.5 rounded-lg transition-colors ${!sesion.tiene_horas_regalo || (sesion.horas_regalo_disponibles ?? 0) <= 0
                                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                                : 'bg-[#61257b] hover:bg-[#8b3fa8] text-white'
                                                                }`}
                                                            title={(sesion.horas_regalo_disponibles ?? 0) <= 0 ? 'No hay horas vigentes disponibles en este período' : 'Usar horas regalo disponibles'}
                                                        >
                                                            <Clock className="w-4 h-4 mr-2" />
                                                            <span className="font-medium">Iniciar horas de regalo</span>
                                                        </button>

                                                        <button
                                                            onClick={() => abrirModalHorasRegalo(sesion)}
                                                            disabled={!sesion.tiene_horas_regalo}
                                                            className={`flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg transition-colors ${!sesion.tiene_horas_regalo
                                                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                                                : 'bg-[#61257b] hover:bg-[#8b3fa8] text-white'
                                                                }`}
                                                            title={!sesion.tiene_horas_regalo ? 'Esta sesión no tiene horas regalo' : 'Ver detalles de horas regalo'}
                                                        >
                                                            <Gift className="w-4 h-4" /><span>Detalles</span>
                                                        </button>

                                                        <button
                                                            onClick={() => abrirModalPago(sesion)}
                                                            disabled={sesion.estado_pago === 'completo'}
                                                            className={`flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg transition-colors font-medium ${sesion.estado_pago === 'completo'
                                                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                                                : 'bg-[#c1348b] hover:bg-[#8f1f64] text-white'
                                                                }`}
                                                        >
                                                            <Banknote className="w-4 h-4 mr-1" /><span>Pagar</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SesionKardexClientesPage;

